import { render, staticRenderFns } from "./Quoter.vue?vue&type=template&id=852bf352&scoped=true&"
import script from "./Quoter.vue?vue&type=script&lang=js&"
export * from "./Quoter.vue?vue&type=script&lang=js&"
import style0 from "./Quoter.vue?vue&type=style&index=0&id=852bf352&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852bf352",
  null
  
)

export default component.exports